import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../../../services/auth.service';
import { NotifyService } from '../../../../services/notify.service';
import { NotityType } from '../../../../model/notify.enun';
@Component({
  selector: 'app-changepass',
  standalone: true,
  templateUrl: './passuser.component.html',
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
})
export class ChangePasswordUserComponent {
  activeModal = inject(NgbActiveModal);
  public auth = inject(AuthService);
  notify=inject(NotifyService);
  fb=inject(FormBuilder);
  public reason = '';
  public user: any;
  public userForm = this.fb.group({
    Password: ['',[
      Validators.required,
      Validators.pattern(
        /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,30}$/
      ),
    ]],
    Confirm: [''],
   
  });

  passwordsMatching: boolean=false;


  checkPasswords() {
    if (this.userForm.value.Password === this.userForm.value.Confirm) {
      this.passwordsMatching = true;
    } else {
      this.passwordsMatching = false;
    }
  }

  
  public close() {
    this.activeModal.close({ action: false });
  }

  public delete() {
    this.activeModal.close({
      action: true,
      reason: this.reason,
      data: this.user,
    });
    var encodedPasswordString = this.userForm.value.Password ? this.userForm.value.Password :'';
    var user = {
      UserID: this.auth.currentUser.User_ID,
      RequesterId: this.auth.currentUser.User_ID,
      password: btoa( encodedPasswordString),
    };

    this.auth.ChangePassword(user).subscribe((p) => {
      if (p !== 'null') {
        this.notify.Notify("Password",'Password has been updated successfully..',NotityType.Success);
        this.auth.LogOut();
      } else {
        this.notify.Notify("Password",'Error while updating password .',NotityType.Danger);
      }
      this.activeModal.close({
        action: true,
      });
    });
  }

  public IsValid(){
    this.checkPasswords();
    return this.userForm.valid && this.passwordsMatching
  }
}
